import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss']
})
export class SearchbarComponent {

  @Input() searchTerm?: string; // Optional input
  @Output() searchChange = new EventEmitter<string>();

  onSearchTermChange() {
    this.searchChange.emit(this.searchTerm);
  }


}
